import $ from "jquery";
import AbstractController from './AbstractController';
import Controller from './Controller';
import {$window, $html, $body, Breakpoints} from '../Constants';

// Utility
import HelperUtility from '../Utility/HelperUtility';

// Service
import HeadlineService from '../Service/HeadlineService';

// HtmlElements
import Banner from '../Elements/Banner';
import BannerCta from '../Elements/BannerCta';
import Header from '../Elements/Header';
import NavSubHorizontal from '../Elements/NavSubHorizontal';
import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import Form from '../Elements/Form';
import CtaBar from '../Elements/CtaBar';
import NavMain from '../Elements/NavMain';
import MetaBar from '../Elements/MetaBar';
import Main from '../Elements/Main';
import BigImageText from '../Elements/BigImageText';
import TextAnimation from '../Elements/TextAnimation';
import AnchorNavigation from '../Extensions/IgGraf/Elements/AnchorNavigation';
import NavLanguage from '../Elements/NavLanguage';
import SlideIn from '../Elements/SlideIn';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 *
 * @class
 */
class PageController extends AbstractController {

  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);

    // Object containing special elements that inherit from HtmlElement
    // relevant page events are delegated to these objects through the controller
    this._registerElements(
      Banner,
      BannerCta,
      Header,
      NavSubHorizontal,
      BackToTopButton,
      ...ContentSlider,
      ...Form,
      CtaBar,
      NavMain,
      MetaBar,
      ...Main,
      ...BigImageText,
      ...TextAnimation,
      NavLanguage,
      SlideIn
    );

		// Initialize HeadlineService
		HeadlineService.initialize();

		window.addEventListener('beforeprint', () => {
			$('img[data-src]').each((i, el) => {
				$(el).attr('src', $(el).data('src'));
			});
		});
	}

  // Private

  /**
   * Adds the javascript for accordions
   *
   * @return void
   */
  _addAccordionJavascript() {
    $('[data-accordion]').each((i, el) => {
      let $accordion = $(el),
        $bigImageText = $accordion.parents('.big-image-text');

      if ($bigImageText.length > 0) {
        let $equalizedRow = $bigImageText.find('> .row'),
          $columns = $equalizedRow.find('> .columns[data-equalizer-watch]');

        $columns.each((i, el) => {
          let $column = $(el),
            equalizedHeight = $column.outerHeight();

          $column.data('equalized-height', equalizedHeight);
        });

        $accordion.on('up.zf.accordion', () => {
          $columns.each((i, el) => {
            let $column = $(el);

            $column.css({
              'height': $column.data('equalized-height'),
              'min-height': ''
            });
          });
        });

        $accordion.on('down.zf.accordion', () => {
          $columns.each((i, el) => {
            let $column = $(el);

            $column.css({
              'height': 'auto',
              'min-height': $column.data('equalized-height')
            });
          });
        });

        $accordion.find('.accordion-title').on('click', () => {
          $columns.each((i, el) => {
            let $column = $(el),
              equalizedHeight = $column.data('equalized-height');

            $column.css('min-height', '');

            if (equalizedHeight > 0) {
              $column.css({
                'height': 'auto',
                'min-height': equalizedHeight
              });
            }
          });
        });
      }
    });
  }

  /**
   * Adds the anchor scrolling functionality
   *
   * @return void
   */
  _addAnchorScrolling() {
    $body.find('[href*="#"]').each((i, el) => {
      let $element = $(el),
        anchor = $element.get(0).hash;

      if (anchor.length > 1) {
        let $elementToScrollTo = $(anchor);

        if ($elementToScrollTo.length === 1) {
          $element.on('click', (e) => {
            e.preventDefault();
            this._scrollToElement($elementToScrollTo);
          });
        }
      }
    });
  }

  /**
   * Scrolls the viewport to the given element
   *
   * @param { jQuery } $element
   * @return void
   */
  _scrollToElement($element) {
    let offset = $element.offset().top;

    if ($window.width() >= Breakpoints.LARGE) {
      offset = offset - Header.getHeight();

      if (AnchorNavigation.exists()) {
        offset = offset - AnchorNavigation.getHeight();
      }
    }

    $('html, body').animate({
      scrollTop: offset
    });
  }

  /**
   * Scrolls automatically to the anchor of the current URL if given and valid
   *
   * @return void
   */
  _scrollToCurrentAnchor() {
    let anchor = window.location.hash;

    if (anchor) {
      let $elementToScrollTo = $(anchor);
      if ($elementToScrollTo.length === 1) {
        $('html, body').animate({
          scrollTop: 0
        }, 0);

        this._scrollToElement($elementToScrollTo);
      }
    }
  }

	_initializeHeaderSearch() {
		const $search = $body.find('#header .search');

		if ($search.length) {
			const $input = $search.find('#search_input');
            const $inputWrap = $search.find('.tx-indexedsearch-searchbox');
			const $searchPlaceholder = $search.find('.search-placeholder');
			const placeholder = $input.attr('placeholder');
			const $toggle = $search.find('.toggle-search');
			$searchPlaceholder.text(placeholder);

			$input.on('focus', () => {
				if ($input.val() === '') {
					$input.closest('.tx-indexedsearch-form').addClass('search-focused');
				}
			});

			$input.on('blur', () => {
				$input.closest('.tx-indexedsearch-form').removeClass('search-focused');
			});

			$input.on('input', () => {
				if ($input.val() === '') {
					$input.closest('.tx-indexedsearch-form').addClass('search-focused');
				} else {
					$input.closest('.tx-indexedsearch-form').removeClass('search-focused');
				}
			});

			const handleToggleClick = () => {
				if ($window.width() >= 400) {
                    $toggle.off('click');
                    $toggle.on('click', (e) => {
						e.preventDefault();
						$input.get(0).focus();
					});
				} else {
                    $toggle.off('click');
                    $toggle.on('click', (e) => {
                        e.preventDefault();
                        if ($inputWrap.css('display') == 'none') {
                            $inputWrap.css('display', 'block');
                            setTimeout( () => {
                                $inputWrap.css('opacity', '1');
                                $inputWrap.css('visibility', 'visible');
                                }, 20);

                        }
                        else {
                            $inputWrap.css('opacity', '0');
                            $inputWrap.css('visibility', 'hidden');
                            setTimeout( () => {
                                $inputWrap.css('display', 'none');
                            }, 1000);

                        }
                    });
                }
			};

			handleToggleClick();
			$window.on('resize', handleToggleClick);
		}
	}

  // Public

	/**
	 * Handles ready event
	 *
	 * @return void
	 */
	onReady() {
		super.onReady();

		$html.attr('data-touch-device', HelperUtility.isTouchDevice());

		if (!HelperUtility.supportsCssFilter()) {
			$html.addClass('no-css-filter');
		}

		this._addAccordionJavascript();
		this._addAnchorScrolling();
		this.checkRowsContainsBox();
		this._initializeHeaderSearch();

		if (window.matchMedia('print').matches) {
			$('img[data-src]').each((i, el) => {
				$(el).attr('src', $(el).data('src'));
			});
		}

        // TODO wofür war das gut?
        // das hat die mailworks formulare (und vermutlich alle) gehindert zweimal abgeschickt zu werden.
        // formular falsch ausfüllen -> absenden mit validierungsfehler -> korrigieren -> erneutes absenden geht nicht!
		// document.querySelectorAll('form').forEach((form) => {
		// 	let submitted = false;
        //
		// 	form.addEventListener('submit', (e) => {
		// 		if (submitted) {
		// 			e.preventDefault();
		// 		}
        //
		// 		submitted = true;
		// 	});
		// });
	}

	/**
	 * Handles load event
	 *
	 * @return void
	 */
	onLoad() {
		this._scrollToCurrentAnchor();
	}

	/**
	 * Checks if equalized rows contain boxes
	 *
	 * @return void
	 */
	checkRowsContainsBox() {
		let $rows = $('.row');

		$rows.each((i, el) => {
			let $row = $(el),
				$columns = $row.find('> .columns');

			$columns.each((i, el) => {
				let $box = $(el).find('.box');

				if ($box.length && $box.length === 1) {
					$(el).addClass('contains-box');
				}
			});
		});
	}
}

export default (new PageController);
